import {
  defaultPlugins,
  generateExternalPlugins,
  generateLanguageUrl,
  tinyMCEConfig,
} from './_utils/TinyMCE'

// export const version = process.env.VERSION
export * from './AnchorNavigation'
export * from './Avatar'
export * from './AvatarStack'
export * from './Badge'
export * from './Banner'
export * from './Box'
export * from './Breadcrumbs'
export * from './Button'
export * from './Calendar'
export * from './Card'
export * from './Checkbox'
export * from './ClickOutside'
export * from './ContactItem'
export * from './Content'
export * from './DateInput'
export * from './DateSelect'
export * from './DetailPage'
export * from './DetailPageTemplate'
export * from './Dropdown'
export * from './DropdownFlyout'
export * from './Dropzone'
export * from './EmptyState'
export { StyledFieldHeader } from './Field'
export * from './FileList'
export * from './FileSelect'
export * from './FileSelect/ThumbnailList'
export * from './FileToken'
export * from './FilterToken'
export * from './Flex'
export * from './FlexList'
export * from './Form'
/**
 * @internal
 * Will require extending types FormFieldProps and FormFieldValueComponentProps
 */
export { BETA_makeField } from './Form'
export * from './GhostPlaceholder'
export * from './Grid'
export * from './GroupSelect'
export * from './Input'
export * from './Link'
export * from './ListPage'
export * from './Menu'
export * from './MenuImperative'
export * from './Modal'
export * from './MultiSelect'
export * from './NextTile'
export * from './Notation'
export * from './NumberInput'
export * from './Overlay'
export * from './OverlayTrigger'
export * from './PageLayout'
export * from './PageTemplate'
export * from './Pagination'
export * from './Panel'
export * from './Pill'
export * from './PillSelect'
export * from './Popover'
export * from './Portal'
export * from './ProgressBar'
export * from './RadioButton'
export * from './Required'
export * from './Search'
export { type SectionProps } from './Section'
export * from './SegmentedController'
export * from './Select'
export * from './Semantic'
export * from './SettingsPage'
export * from './SettingsPageTemplate'
export * from './Slider'
export * from './Spinner'
export * from './SplitViewCard'
export * from './SuperSelect'
export * from './Switch'
export * from './Table'
export * from './TableShelf'
export * from './Tabs'
export * from './Tearsheet'
export * from './TextArea'
export * from './TextEditor'
export * from './TextEditorOutput'
export * from './TextInput'
export * from './Thumbnail'
export * from './TieredDropdown'
export * from './TieredSelect'
export * from './Tile'
export * from './Title'
export * from './Toast'
export * from './ToggleButton'
export * from './Token'
export * from './ToolHeader'
export * from './ToolLandingPage'
export * from './ToolLandingPageTemplate'
export * from './Tooltip'
export * from './Tree'
export * from './Typeahead'
export * from './Typography'
/** UNSAFE Template exports */
export * from './UNSAFE_TEMPLATES_index'
export * from './_hooks/Anchor'
export * from './_hooks/Buffer'
export * from './_hooks/ClickOutside'
export * from './_hooks/DateTime'
export * from './_hooks/DelayedCallback'
export * from './_hooks/DelayedToggle'
export * from './_hooks/Deprecation'
export * from './_hooks/EventListener'
/**
 * @deprecated
 */
export {
  OverridableFocusScope as UNSAFE_OverridableFocusScope,
  useOverridableFocusScope as UNSAFE_useOverridableFocusScope,
} from './_hooks/FocusScopeOverride'
export { getI18nProviderLocale } from './_hooks/getI18nProviderLocale'
export * from './_hooks/Hotkey'
export * from './_hooks/I18n'
export * from './_hooks/InjectedScript'
export * from './_hooks/ListNavigation'
export * from './_hooks/OverflowObserver'
export * from './_hooks/Resize'
/**
 * @internal
 */
export { useResizeObserver as UNSAFE_useResizeObserver } from './_hooks/ResizeObserver'
export * from './_hooks/Scroll'
export * from './_hooks/TextEntry'
export * from './_hooks/Timer'
export * from './_hooks/Trigger'
/**
 * @internal
 */
export {
  type UNSAFE_GetEndpoint,
  type UNSAFE_GetPayloadKey,
  type UNSAFE_UploadFile,
} from './_hooks/useFileUploader'
export * from './_hooks/Visibility'
export * from './_hooks/ZIndex'
// Style Stuff
export {
  borderRadius,
  getBorderRadius as UNSAFE_getBorderRadius,
} from './_styles/borderRadius'
export * from './_styles/colors'
/**
 * @internal
 */
export {
  getEllipsis as UNSAFE_getEllipsis,
  getFocus as UNSAFE_getFocus,
  getLineClamp as UNSAFE_getLineClamp,
} from './_styles/mixins'
export * from './_styles/spacing'
/**
 * @internal
 */
export { addSubcomponents as UNSAFE_addSubcomponents } from './_utils/addSubcomponents'
export { getMonthLabel } from './_utils/CalendarHelpers'
/**
 * @internal
 */
export { intlDateTimeFormat } from './_utils/dateTime'
/**
 * @internal
 */
export { parseFilename as UNSAFE_parseFilename } from './_utils/filename'
/**
 * @internal
 */
export { mergeRefs as UNSAFE_mergeRefs } from './_utils/mergeRefs'
// export { getTypographyIntent, typographyWeights } from './Typography'
// For documentation only
export { docsProps as UNSAFE_props } from './_utils/props'
export type { DivAttributes, Placement, SpanAttributes } from './_utils/types'

/** @deprecated */
export const tinyMCE = {
  defaultPlugins,
  generateExternalPlugins,
  generateLanguageUrl,
  config: tinyMCEConfig,
}
